// extracted by mini-css-extract-plugin
export default {"component":"SchedulerCell_component__BipGm","isWeek":"SchedulerCell_isWeek__19vC9","placeholder":"SchedulerCell_placeholder__c6n0Y","isDay":"SchedulerCell_isDay__auuZJ"};